import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const tourParamsSchema = object({
  tourId: stringToNumber()
})
